import { FC } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useBreakpointValue, useDisclosure } from "@chakra-ui/react";
import { List } from "@chakra-ui/layout";
import { DeleteAlertDialog, IconButtonDelete, IconButtonEdit, IconButtonExternalLink } from "components";
import { useDnd, useDndAsset } from "domains/drag-and-drop";
import { EditLinkModal } from "./modals";
import { openLink } from "./utils";
import { embeddableContentTypes } from 'lib/utils';
import { container, item, QuickActionEmbed } from "../../shared";

export const LinkQuickActions: FC<any> = ({ isActive }) => {
  const { isMultipleSelected } = useDnd();
  const { isDragging, isSelected, asset } = useDndAsset();
  const isMobile = useBreakpointValue([true, true, false]);
  const editModal = useDisclosure();
  const deleteDialog = useDisclosure();

  if (isMobile) {
    return null;
  }

  const isEmbeddable = !asset.enc_data || embeddableContentTypes.includes(asset.data.content_type);

  return (
    <>
      <AnimatePresence>
        {((isSelected || isActive) && !isMultipleSelected && !isDragging) && (
          <List
            layerStyle={"with-quick-actions"}
            gridTemplateColumns="repeat(4, 1fr)"
            as={motion.ul}
            variants={container}
            initial="hidden"
            animate="show"
            exit="hidden"
          >
            <motion.li variants={item}>
              <IconButtonExternalLink onClick={(e) => openLink(e, asset)} />
            </motion.li>
            <motion.li variants={item}>
              <IconButtonEdit onClick={editModal.onOpen} />
            </motion.li>
            {isEmbeddable && (
              <motion.li variants={item}>
                <QuickActionEmbed asset={asset} />
              </motion.li>
            )}
            <motion.li variants={item}>
              <IconButtonDelete onClick={deleteDialog.onOpen} />
            </motion.li>
          </List>
        )}
      </AnimatePresence>
      <EditLinkModal
        isOpen={editModal.isOpen}
        onClose={editModal.onClose}
        asset={asset}
      />
      <DeleteAlertDialog
        title={"Are you sure you want to delete this asset?"}
        content={"This action cannot be undone."}
        isOpen={deleteDialog.isOpen}
        onClose={deleteDialog.onClose}
        asset={asset}
      />
    </>
  )
};
